import { Divider, LayoutBand, useContainerWidth } from '@fs/zion-ui'
import React, { type ReactNode } from 'react'
import { usePersonPageParams } from './personPageRouteUtil'
import PersonBannerSkeleton from './components/person-banner/PersonBannerSkeleton'
import SourceCentricBannerSkeleton from './components/person-banner/SourceCentricBannerSkeleton'
import PersonPageTabsSkeleton from './components/PersonPageTabsSkeleton'
import PersonPageContentSkeleton from './PersonPageContentSkeleton'
import useSourceCentricDetailsFlag from '../data-service/useSourceCentricDetailsFlag'

type Props = {
  children?: ReactNode
}

export default function PersonPageSkeleton({ children }: Props = {}): JSX.Element {
  const atContainerWidth = useContainerWidth()
  const isMobile = atContainerWidth({ lg: false, default: true })
  const { subPage } = usePersonPageParams('partial')
  const { data: sourceCentricDetailsFlag } = useSourceCentricDetailsFlag()
  const isSourceCentricDetails = subPage === 'details' && !!sourceCentricDetailsFlag?.isOn

  if (children) {
    return <>{children}</>
  }

  return (
    <div style={{ minHeight: '100vh' }}>
      {isSourceCentricDetails ? <SourceCentricBannerSkeleton /> : <PersonBannerSkeleton isMobile={isMobile} />}
      <Divider />
      <PersonPageTabsSkeleton />
      <LayoutBand
        maxWidth="lg"
        marginY={isSourceCentricDetails ? 'sm' : 'nano'}
        marginX={isSourceCentricDetails ? 'sm' : 'nano'}
      >
        <PersonPageContentSkeleton />
      </LayoutBand>
    </div>
  )
}
